app.controller("NotificationsIndexController", ["$scope", "$stateParams", "Students", "$uibModal", "$state", "NotificationService", "usSpinnerService",
    function ($scope, $stateParams, Students, $uibModal, $state, NotificationService, usSpinnerService) {
        $scope.notifications = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;
        $scope.title = null;
        $scope.query = $stateParams.query;
        $scope.fromDate = $stateParams.fromDate;
        $scope.toDate = $stateParams.toDate;

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.open = function (notification) {
            $uibModal.open({
                controller: "NotificationsWindowController",
                templateUrl: _pb + 'notifications/notification-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {notification: notification};
                    }
                }
            }).result
                .then(function (result) {

                }, function () {

                });
        };

        $scope.editNotification = function (notification) {
            $state.go("admin.createNotifications", {
                operationType: 'edit',
                notificationId: notification._id
            });
        };

        $scope.resendNotification = function (notification) {
            $state.go("admin.createNotifications", {
                operationType: 'resend',
                notificationId: notification._id
            });
        };

        function loadPage(page, query, fromDate, toDate, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            NotificationService.sendList({
                page: page,
                query: query,
                fromDate: fromDate,
                toDate: toDate,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.notifications = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.create = function () {
            $state.go("admin.createNotifications", {});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate
            });
        };

        $scope.createNotificationReminder = function (notification, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "RemindersCreateModalController",
                templateUrl: _pb + 'admin/reminders/create.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            type: 'notification',
                            text: 'გატყობინებთ, რომ გასაგზავნია შეტყობინება სათაურით: ' + notification.title,
                            route: 'admin.createNotifications',
                            routeParams: {
                                operationType: 'resend',
                                notificationId: notification._id
                            }
                        }
                    }
                }
            }).result
                .then(function (result) {

                });
        };
    }
]);
